export default __webpack_public_path__ + "static/media/arrowUp.8b74fac7.svg";